<template>
  <div v-show="!loading">
    <h3 class="Contracts mt-30 mb-25">Bill Of Lading (Direct sales)</h3>
    <div class="bg-white py-40">
      <div class="row p-lg-0 p-20">
        <div class="col-lg-7 col-md-12 m-auto">
          <div class="form-group">
            <div class="form-row">
              <div class="col-lg-3 col-md-12">
                <label class="col-form-label">Bill of Lading</label>
              </div>
              <div class="col-lg-7 col-md-12">
                <div class="form-group">
                  <div class="drop drop-inline drop-sm">
                    <div class="cont">
                      <img alt=""
                           src="@/assets/img/icons/upload1.svg">
                      <div v-if="!billOfLadingForm.file.tsync_id" class="desc"> Upload Excel File</div>
                      <div v-if="billOfLadingForm.file.tsync_id" class="desc">{{ billOfLadingForm.file.name }}</div>
                    </div>
                    <input ref="fileUploader" accept=".xls, .xlsx"
                           type="file"
                           @change="onExcelChange($event)" @click="resetFileUploader">
                    <div
                      v-if="$v.$error & !$v.billOfLadingForm.file.tsync_id.required"
                      class="error">
                      An excel file is required.
                    </div>
                  </div>
                  <div class="d-inline-flex">
                    <i v-show="billOfLadingForm.file.tsync_id" aria-hidden="true"
                       class="fa fa-times ml-2 clear-file"
                       @click="clearFile(billOfLadingForm)"> Clear</i>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-md-12">
                <div class="text-right">
                  <div class="d-inline-flex">
                    <button v-if="!isObserverUser"
                            :disabled="!Object.keys(billOfLadingContents).length || !isSaveButtonActive"
                            class="btn btn-submit" type="button"
                            @click="saveBillOfLading"> {{ saveButtonTxt }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group mb-30">
            <div class="row">
              <div class="col-12 col-md-12 col-lg-12 col-sm-12">
                <h4 v-show="fileLoading" class="text-warning">
                  <span v-show="!Object.keys(billOfLadingContents).length">
                    Excel is loading. Please wait a moment
                  </span>
                </h4>
                <h6 v-show="uploadPercentage"
                    :class="uploadPercentage === 100 ? 'text-success':'text-warning'">
                    <span v-show="uploadPercentage!==100">
                     Please don't close this TAB before the upload is 100% completed.
                    </span>
                </h6>
                <div v-show="uploadPercentage && uploadPercentage!==100" class="progress">
                  <div :style="'width: '+uploadPercentage+'%'" aria-valuemax="100"
                       aria-valuemin="0" aria-valuenow="1" class="progress-bar progress-bar-striped bg-success"
                       role="progressbar">{{ uploadPercentage }}%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row p-lg-0 p-20">
        <div class="col-md-12">
          <div class="p-3">
            <Table
              :api-prefix="apiPrefix"
              :committed-store="'setTraceabilityBillOfLadingContent'"
              :dispatched-store="'getBillOfLadingsFromServer'"
              :is-data-fetched="loading"
              :table-data="tableData"
              :table-headers="tableHeaders"
              :table-search-config="tableSearchConfig"
              @updatedTableContents="getTableData"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormMixin from '@/mixins/form-mixin'
import { validationMixin } from 'vuelidate'
import UtilityMixin from '@/mixins/utility-mixin'
import { required } from 'vuelidate/lib/validators'
import xlsx from 'xlsx'
import Table from '@/components/admin/traceability/Table'
import moment from 'moment'
import { ContentTypes } from '@/config/constants'
import Menus from '@/config/menus'
import _ from 'lodash'

export default {
  name: 'AllCountryBillOfLading',
  components: { Table },
  data () {
    return {
      billOfLadingForm: {
        file: {
          file: null,
          name: null,
          tsync_id: null
        }
      },
      billOfLadingContents: {},
      tableHeaders: [
        {
          title: 'Customer ID',
          subtitle: ''
        },
        {
          title: 'Customer',
          subtitle: ''
        },
        {
          title: 'Importer ID',
          subtitle: ''
        },
        {
          title: 'Importer',
          subtitle: ''
        },
        {
          title: 'Contract',
          subtitle: 'No'
        },
        {
          title: 'Shipment',
          subtitle: ''
        },
        {
          title: 'Bill',
          subtitle: 'Of Lading'
        },
        {
          title: 'Port',
          subtitle: 'Of Origin'
        },
        {
          title: 'Port',
          subtitle: 'Origin GPS'
        },
        {
          title: 'Port',
          subtitle: 'Of Destination'
        },
        {
          title: 'Port',
          subtitle: 'Of Destination GPS'
        },
        {
          title: 'Mill',
          subtitle: ''
        },
        {
          title: 'Mill',
          subtitle: 'GPS'
        }
      ],
      tableSearchConfig: [
        {
          header: 'Customer ID',
          db_representation: 'contract__customer__public_code',
          widget_type: 'text'
        },
        {
          header: 'Customer',
          db_representation: 'contract__customer__name',
          widget_type: 'text'
        },
        {
          header: 'Importer ID',
          db_representation: 'contract__importer__public_code',
          widget_type: 'text'
        },
        {
          header: 'Importer',
          db_representation: 'contract__importer__name',
          widget_type: 'text'
        },
        {
          header: 'Contract No',
          db_representation: 'contract__contract_no',
          widget_type: 'text'
        },
        {
          header: 'Shipment',
          db_representation: 'contract__shipment__shipment_start_date__gte,contract__shipment__shipment_end_date__lte',
          widget_type: 'date_range'
        },
        {
          header: 'Bill Of Lading',
          db_representation: 'bill_of_lading_number',
          widget_type: 'text'
        },
        {
          header: 'Port Of Origin',
          db_representation: 'port_of_origin__name',
          widget_type: 'text'
        },
        {
          header: 'Port Origin GPS',
          db_representation: 'port_of_origin__location__latitude__gte,port_of_origin__location__longitude__lte',
          widget_type: 'number_range'
        },
        {
          header: 'Port Of Destination',
          db_representation: 'port_of_destination__name',
          widget_type: 'text'
        },
        {
          header: 'Port Of Destination GPS',
          db_representation: 'port_of_destination__location__latitude__gte,port_of_destination__location__longitude__lte',
          widget_type: 'number_range'
        },
        {
          header: 'Mill',
          db_representation: 'mill__name',
          widget_type: 'text'
        },
        {
          header: 'Mill GPS',
          db_representation: 'mill__location__latitude__gte,mill__location__longitude__lte',
          widget_type: 'number_range'
        }
      ],
      searchDict: {
        searchField: '',
        searchText: '',
        date: '',
        fromDate: '',
        toDate: '',
        fromNumber: '',
        toNumber: ''
      },
      paginateDict: {
        nextUrl: null,
        previousUrl: null,
        currentPage: 1,
        totalPage: 1,
        firstPage: null,
        lastPage: null,
        remainingCount: 0,
        nextOffset: 0,
        totalCount: 0,
        dataPerPage: 5,
        previousPageNumber: 0,
        currentPageNumber: 0,
        nextPageNumber: 0
      },
      apiPrefix: 'v1/bill-of-lading',
      tableData: [],
      loading: false,
      fileLoading: false,
      fileTsyncIdMapping: {},
      loadingText: 'Excel is loading. Please wait a moment',
      isSaveButtonActive: true,
      saveButtonTxt: 'Submit',
      uploadPercentage: 0
    }
  },
  mixins: [FormMixin, validationMixin, UtilityMixin],
  validations: {
    billOfLadingForm: {
      file: {
        tsync_id: { required }
      }
    }
  },
  computed: {
    billOfLadingsContent () {
      return this.$store.getters.getTraceabilityAllCountryBillOfLadingContents
    }
  },
  methods: {
    resetFileUploader () {
      // It reset image or file uploader if same file selected again
      this.$refs.fileUploader.value = ''
    },
    async onExcelChange (e) {
      this.billOfLadingContents = {}
      if (e.target.files.length > 0) {
        const file = e.target.files[0]
        this.billOfLadingForm.file.file = file
        this.billOfLadingForm.file.name = file.name
        this.billOfLadingForm.file.tsync_id = this.uuidV4()
        this.fileLoading = false
        await this.prepareBillOfLadingData()
        this.fileLoading = true
      } else {
        // if excel upload widget clicked and no file selected
        this.billOfLadingForm.file.file = null
        this.billOfLadingForm.file.name = null
        this.isChartPreviewed = false
        this.billOfLadingForm.file.tsync_id = null
      }
    },
    async prepareBillOfLadingData () {
      if (this.billOfLadingForm.file.file) {
        const file = this.billOfLadingForm.file.file
        const fileReader = new FileReader()
        fileReader.onload = ev => {
          try {
            const data = ev.target.result
            const XLSX = xlsx
            const workbook = XLSX.read(data, {
              type: 'binary'
            })
            const wsname = workbook.SheetNames[0] // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
            const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname])

            const excelData = [] // Clear received data
            //
            const wsLength = ws.length
            for (var i = 0; i < wsLength; i++) {
              excelData.push(ws[i])
            }
            this.billOfLadingContents = excelData
          } catch (e) {
            return console.log('File can\'t read!')
          }
        }
        fileReader.readAsBinaryString(file)
      }
    },
    async saveBillOfLading () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$notify({
          title: '',
          text: 'Please fix error(s) in form.',
          type: 'error',
          duration: 5000
        })
      } else {
        this.isSaveButtonActive = false
        this.saveButtonTxt = 'Submitting...'
        const vm = this

        // start file upload log
        const fileUploadLogPromises = []
        const response = this.createFileUploadLog(this.billOfLadingForm)
        fileUploadLogPromises.push(response)

        Promise.all(fileUploadLogPromises).then((values) => {
          const filePromises = []
          values.map((item) => {
            const fileId = item.data.file ? item.data.file.id : 0
            const fileTsyncId = item.data.file ? item.data.file.tsync_id : ''
            if (fileId === 0 || fileTsyncId === '') return
            const file = this.fileTsyncIdMapping[fileTsyncId]
            if (!file) return
            const response = this.uploadFile(fileId, file)
            filePromises.push(response)
          })
          Promise.all(filePromises).then((fileResponses) => {
            // this.$notify({
            //   title: '',
            //   text: 'File upload log created successfully.',
            //   type: 'success', // 'warn', 'error', 'success'
            //   duration: 5000
            // })
            this.$forceUpdate()
          })
        })
        // end file upload log

        let dataPosted = 0
        let dataNotPosted = 0
        const tempData = []

        const billOfLadingPromises = []
        let billOfLadingUploadCount = 0
        const totalBillOfLading = _.size(vm.billOfLadingContents)
        const promises = await vm.billOfLadingContents.reduce(async (memo, v) => {
          await memo
          const response = vm.submitEachBillOfLading(v)
          var myPromise = this.MakeQuerablePromise(response)
          response.then(function (data) {
            if (myPromise.isFulfilled()) {
              billOfLadingUploadCount += 1
              vm.uploadPercentage = Math.ceil(billOfLadingUploadCount / totalBillOfLading * 100)
            }
          })
          billOfLadingPromises.push(response)
        }, [])
        _.unset(promises, '')

        Promise.all(billOfLadingPromises).then((values) => {
          values.map((item) => {
            const data = item.data
            if (data.success) {
              if (!_.get(data, 'results')) {
                tempData.push(data)
              } else {
                this.$store.commit('setTraceabilityBillOfLadingContent', data.results)
              }
              dataPosted += 1
            } else {
              this.$notify({
                title: 'Bill of Lading',
                text: data.message,
                type: 'error', // 'warn', 'error', 'success'
                duration: 10000
              })
              dataNotPosted += 1
              vm.errorLog(item)
            }
          })

          this.isSaveButtonActive = true
          this.saveButtonTxt = 'Submit'
          if (tempData.length > 0) {
            vm.$store.commit('setTraceabilityBillOfLadingContent', tempData)
            this.getTableData(tempData)
          }
          if (dataNotPosted > 0) {
            this.$notify({
              title: 'Bill of Lading',
              text: `${dataNotPosted} bill of lading not created/ updated.`,
              type: 'error'
            })
          }
          if (dataPosted > 0) {
            this.$notify({
              title: 'Bill of Lading',
              text: `${dataPosted} bill of lading created/ updated successfully.`,
              type: 'success', // 'warn', 'error', 'success'
              duration: 5000
            })
          }
        })
      }
    },
    async submitEachBillOfLading (data) {
      const formData = this.$_.cloneDeep(data)
      return await this.$store.dispatch('createOrUpdateTraceabilityBillOfLadingContent', formData)
    },
    getTableData (payload) {
      if (payload) {
        payload = this.$store.getters.getTraceabilityAllCountryBillOfLadingContents
      }
      this.tableData = []
      for (const _data of payload) {
        const tempData = []
        tempData.push(_.get(_data, 'contract.customer.public_code') || 'N/A')
        tempData.push(_.get(_data, 'contract.customer.name') || 'N/A')
        tempData.push(_.get(_data, 'contract.importer.public_code') || 'N/A')
        tempData.push(_.get(_data, 'contract.importer.name') || 'N/A')
        tempData.push(_.get(_data, 'contract.contract_no') || 'N/A')
        const contract = _.get(_data, 'contract') || null
        if (contract) {
          tempData.push(moment(_data.contract.shipment_start_date).format('DD.MM.YYYY') + ' - ' + moment(_data.contract.shipment_end_date).format('DD.MM.YY'))
        } else {
          tempData.push('N/A')
        }

        tempData.push(_.get(_data, 'bill_of_lading_number') || 'N/A')
        tempData.push(_.get(_data, 'port_of_origin.name') || 'N/A')
        const polLatitude = _.get(_data, 'port_of_origin.location.latitude') || null
        const polLongitude = _.get(_data, 'port_of_origin.location.longitude') || null
        if (polLatitude && polLongitude) {
          tempData.push(polLatitude + ', ' + polLongitude)
        } else {
          tempData.push('N/A')
        }
        tempData.push(_.get(_data, 'port_of_destination.name') || 'N/A')
        const podLatitude = _.get(_data, 'port_of_destination.location.latitude') || null
        const podLongitude = _.get(_data, 'port_of_destination.location.longitude') || null
        if (podLatitude && podLongitude) {
          tempData.push(podLatitude + ', ' + podLongitude)
        } else {
          tempData.push('N/A')
        }
        tempData.push(_.get(_data, 'mill_name') || 'N/A')
        const millLatitude = _.get(_data, 'mill.location.latitude') || null
        const millLongitude = _.get(_data, 'mill.location.longitude') || null
        if (millLatitude && millLongitude) {
          tempData.push(millLatitude + ', ' + millLongitude)
        } else {
          tempData.push('N/A')
        }
        this.tableData.push(tempData)
      }
      return this.tableData
    },
    async createFileUploadLog (data) {
      const formData = this.$_.cloneDeep(data)
      const fileTsyncId = (formData.file && formData.file.tsync_id) ? formData.file.tsync_id : this.uuidV4()
      this.fileTsyncIdMapping[fileTsyncId] = data.file.file
      if (this.billOfLadingForm.file.file) {
        if (!formData.id) {
          formData.file = {
            tsync_id: fileTsyncId,
            extension: formData.file.name.split('.').pop()
          }
        } else {
          try {
            formData.file.extension = formData.file.name.split('.').pop()
          } catch (e) {
            this.errorLog(e)
          }
        }
      }
      formData.content_type = ContentTypes.FILE
      formData.content = this.$store.getters.getContentByAppModule(Menus.traceability.key).id
      return await this.$store.dispatch('createOrUpdateTraceabilityContents', formData)
    }
  },
  watch: {
    billOfLadingsContent: {
      deep: true,
      handler (newValue) {
        this.billOfLadings = _.cloneDeep(newValue)
      }
    }
  },
  created () {
    window.onbeforeunload = () => (this.uploadPercentage ? true : null)
  }
}
</script>

<style lang="scss" scoped>

.clear-file {
  cursor: pointer;
}

.drop-sm {
  padding-right: 60px !important;
  max-width: 100%; // if file name is long than it wont overflow next close button
}
</style>
